import { getWidgetsConfig } from '~utils';

export const getParticipantMode = (): string | null => {
  return getWidgetsConfig('data-participant-mode');
};

export const getApiSixClientId = (): string => {
  const apiKey = getWidgetsConfig('data-client-id');
  if (!apiKey) {
    throw new Error('Client ID is missing from the widget configuration');
  }
  return apiKey;
};

export const getTargetShopUrl = (): string => {
  const apiKey = getWidgetsConfig('data-shop-url');
  if (!apiKey) {
    throw new Error('Shop URL is missing from the widget configuration');
  }
  return apiKey;
};

/**
 * Navigates back if the referrer is on the same origin, otherwise redirects to home.
 * Used by widget back buttons (mobile header chevron).
 */
export const smartBack = (): void => {
  const { referrer } = document;
  if (referrer?.includes(globalThis.location.hostname)) {
    globalThis.history.back();
  } else {
    globalThis.location.href = '/';
  }
};
